import React from "react";

export default function Email({ className }) {
  return (
    <svg
      width="40"
      height="40"
      x="0"
      y="0"
      viewBox="0 0 512 512"
      className={className}
    >
      <g>
        <path
          fillRule="evenodd"
          d="M256 512C114.841 512 0 397.159 0 256S114.841 0 256 0s256 114.841 256 256-114.841 256-256 256zm132.758-166.069a5.732 5.732 0 0 0 5.725-5.725V179.489l-130.25 103.432c-2.41 1.915-5.323 2.872-8.234 2.872s-5.823-.958-8.234-2.872L117.516 179.489v160.717a5.732 5.732 0 0 0 5.725 5.725zm-19.96-179.862L256 255.644l-112.799-89.575zm52.168 5.725v168.414c0 17.759-14.449 32.208-32.208 32.208H123.241c-17.76 0-32.207-14.449-32.207-32.208V171.794c0-17.759 14.448-32.207 32.207-32.207h265.517c17.759-.001 32.208 14.448 32.208 32.207z"
          clipRule="evenodd"
          fill="currentColor"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}
